import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import Notifications from '../Notifications';

const StyledBoxNotification = styled.div`
  background-color: ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.dark};
  box-shadow: ${rem('-2px')} ${rem('2px')} ${rem('2px')} 0
    rgba(25, 25, 25, 0.16);
  margin: 0;
  padding: ${rem('30px')} 0;
  position: relative;
  max-height: ${rem('400px')};
  overflow-y: auto;
  font-size: ${rem('14px')};

  &:after {
    border-left: ${rem('10px')} solid transparent;
    border-right: ${rem('10px')} solid transparent;
    border-top: ${rem('12px')} solid ${props => props.theme.colors.light};
    content: '';
    display: block;
    height: 0;
    position: absolute;
    right: 3.75rem;
    top: -${rem('1px')};
    width: 0;
  }

  ${mediaqueries.greaterThan('mobile')`
    &:after {
      right: ${rem('112px')};
    }
  `};
  ${mediaqueries.greaterThan('desktop')`
    &:after {
      right: 0;
    }
  `};
`;

const StyledIconCollapseNot = styled(Icon)`
  position: absolute;
  right: 5.9rem;
  top: ${rem('11px')};
  z-index: 1;
  cursor: pointer;
  ${mediaqueries.greaterThan('mobile')`
    right: ${rem('114px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    right: ${rem('14.4px')};
  `};
`;

const StyledIconArrow = styled(Icon)`
  fill: ${props => props.theme.colors.light};
  transform: rotate(180deg);
  cursor: pointer;
  width: ${rem('14px')};
  height: ${rem('10px')};
  position: absolute;
  left: 0;
  top: ${rem('6px')};
`;

const StyledIconOptions = styled(Icon)`
  fill: ${props => props.theme.colors.dark};
  transform: rotate(180deg);
  cursor: pointer;
  width: ${rem('88px')};
  height: ${rem('24px')};
  margin-right: 25px;
  position: initial;
  left: 0;
  top: ${rem('6px')};
`;

const StyledTitleNotification = styled.div`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.large};
  font-weight: bolder;
  margin: 0 ${rem('40px')} ${rem('17px')} ${rem('40px')};
  text-transform: uppercase;
  padding-bottom: ${rem('11px')};
  position: relative;
  padding: 0 0 ${rem('11px')} ${rem('23px')};
  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: ${rem('8px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('26px')};
  `};
`;

const StyledListNotification = styled.button`
  align-items: center;
  background: none;
  border: 0;
  color: ${props => props.theme.colors.dark};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  margin-left: 0;
  min-height: ${rem('60px')};
  padding: 0 ${rem('40px')};
  position: relative;
  width: 100%;

  &:hover {
    background-color: ${props => props.theme.colors.grayDarkest};
    color: ${props => props.theme.colors.light};
    border-right: ${rem('4px')} solid ${props => props.theme.colors.primary};
    cursor: pointer;
  }

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

const StyledIconNotList = styled(Notifications)`
  position: absolute;
  right: ${rem('-30.2px')};
  top: ${rem('-14.4px')};
`;

const StyledBoxIconNot = styled.span`
  margin-right: ${rem('20px')};
  position: relative;
  stroke: black;
`;

const StyledEmpty = styled.p`
  font-family: ${props => props.theme.fonts.mediumItalic};
  font-size: ${rem('14px')};
  color: ${props => props.theme.colors.gray};
  margin-left: ${rem('63px')};
`;

export {
  StyledBoxNotification,
  StyledIconCollapseNot,
  StyledIconArrow,
  StyledIconOptions,
  StyledTitleNotification,
  StyledListNotification,
  StyledIconNotList,
  StyledBoxIconNot,
  StyledEmpty
};
